<template>
  <span>
    <v-btn text small color="primary" @click="$emit('compare')">
      Compare plans
    </v-btn>
    <v-btn v-if="full" text small color="primary" @click="$emit('manage')">
      Manage data
    </v-btn>
  </span>
</template>

<script>
export default {
  name: "IngestionQuotaActions",
  props: {
    full: Boolean
  }
};
</script>
